import React, { useEffect } from "react";
import { Helmet } from "react-helmet-async";
import { gtag } from "../utils/gtag";
import { MAILTO_URL } from "../utils/constants";
import "./Gallery.css";

const SOCIABLEKIT_SCRIPT_SRC =
  "https://widgets.sociablekit.com/instagram-feed/widget.js";

const Gallery = () => {
  useEffect(() => {
    let script: HTMLScriptElement | null = document.querySelector(
      `script[src="${SOCIABLEKIT_SCRIPT_SRC}"]`
    );
    if (!script) {
      script = document.createElement("script");
      script.src = SOCIABLEKIT_SCRIPT_SRC;
      script.defer = true;
      document.body.appendChild(script);
    }
    return () => {
      if (script && script.parentNode) {
        script.parentNode.removeChild(script);
      }
    };
  }, []);

  return (
    <div className="gallery-container">
      <Helmet>
        <title>Gallery | Blossom and Graze Bristol – Grazing Board Inspiration</title>
        <meta name="description" content="Browse our gallery of beautiful grazing boards and event catering by Blossom and Graze Bristol. Follow us on Instagram @blossomandgrazebristol for daily inspiration." />
        <link rel="canonical" href="https://www.blossomandgraze.co.uk/gallery" />
        <meta property="og:url" content="https://www.blossomandgraze.co.uk/gallery" />
        <meta property="og:title" content="Gallery | Blossom and Graze Bristol – Grazing Board Inspiration" />
        <meta property="og:description" content="Browse our gallery of beautiful grazing boards and event catering by Blossom and Graze Bristol. Follow us on Instagram @blossomandgrazebristol." />
      </Helmet>
      <div className="instagram-feed-section">
        <h2 className="instagram-feed-heading">Follow Us on Instagram</h2>
        <p className="instagram-feed-subheading">
          @blossomandgrazebristol
        </p>
        <div
          className="sk-instagram-feed"
          data-embed-id="25669345"
        ></div>
      </div>

      <div className="gallery-cta">
        <p>Ready to create your own special moment?</p>
        <a href={MAILTO_URL} className="cta-button" onClick={() => {
          gtag("event", "enquire_click", {
            link_location: "gallery_cta",
          });
        }}>
          Enquire Now
        </a>
      </div>
    </div>
  );
};

export default Gallery;
